import { useEffect } from "react";

import { ThemeSync } from "@/app/ThemeSync";
import { useRestoreSession } from "@/features/auth/useAuth";
import AppRouter from "@/lib/router/router";

/**
 * useRestoreSession only needs Redux — no router context.
 * It dispatches credentials to the store; AuthGuard/GuestGuard
 * handle the redirect once RouterProvider renders.
 */
function AppInner() {
  const restoreSession = useRestoreSession();

  useEffect(() => {
    void restoreSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AppRouter />;
}

export default function App() {
  return (
    <>
      <ThemeSync />
      <AppInner />
    </>
  );
}
